// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";
import {
  Transform,
  Crop,
  ColorAdjust,
  VideoFx,
  TransitionRef,
  AudioFx,
  TextProps,
  Keyframe,
} from "./types";


export default __t.row({
  id: __t.string().primaryKey(),
  projectId: __t.string().name("project_id"),
  orgId: __t.string().name("org_id"),
  trackId: __t.string().name("track_id"),
  kind: __t.string(),
  assetId: __t.option(__t.string()).name("asset_id"),
  name: __t.string(),
  startUs: __t.f64().name("start_us"),
  durationUs: __t.f64().name("duration_us"),
  inUs: __t.f64().name("in_us"),
  speed: __t.f64(),
  get transform() {
    return Transform;
  },
  get crop() {
    return Crop;
  },
  get color() {
    return ColorAdjust;
  },
  get videoFx() {
    return VideoFx.name("video_fx");
  },
  videoFadeInUs: __t.f64().name("video_fade_in_us"),
  videoFadeOutUs: __t.f64().name("video_fade_out_us"),
  get transitionIn() {
    return __t.option(TransitionRef).name("transition_in");
  },
  volume: __t.f64(),
  muted: __t.bool(),
  audioFadeInUs: __t.f64().name("audio_fade_in_us"),
  audioFadeOutUs: __t.f64().name("audio_fade_out_us"),
  get audioFx() {
    return AudioFx.name("audio_fx");
  },
  get text() {
    return __t.option(TextProps);
  },
  fillColor: __t.string().name("fill_color"),
  get keyframes() {
    return __t.array(Keyframe);
  },
  linkId: __t.option(__t.string()).name("link_id"),
  lockedBy: __t.option(__t.identity()).name("locked_by"),
  lockedByName: __t.string().name("locked_by_name"),
  updatedAt: __t.timestamp().name("updated_at"),
  updatedByName: __t.string().name("updated_by_name"),
  get transitionOut() {
    return __t.option(TransitionRef).name("transition_out");
  },
  ext: __t.string(),
  scopeId: __t.string().name("scope_id"),
});
